import getConfig from 'next/config'

const { publicRuntimeConfig } = getConfig()

export const getClientHost = () =>
  typeof window !== 'undefined'
    ? window.location.host
    : new URL('', publicRuntimeConfig.WEB_BASE_URL).host
